/**
 * 止まらずに流し続ける列の共通部品（Instagramの列とFVの写真で使う）
 *
 * @description 流す量は経過時間から決める。フレームの間隔に任せると、処理の重い端末ほど遅く流れる
 */

/** 流す速さの元。デザイン幅6933ぶんを60秒で流す */
const CRAWL_WIDTH = 6933;
const CRAWL_SEC = 60;

/** 1秒あたりに流す距離（デザイン幅1728基準px） */
const CRAWL_PER_SEC = CRAWL_WIDTH / CRAWL_SEC;

/** 1フレームで進める上限(秒)。タブを離れて戻ったときに一気に飛ばさない */
const MAX_DELTA = 1 / 20;

/**
 * 1組ぶんの範囲へ畳む
 *
 * @description 同じ絵柄が並ぶ位置へ移すだけなので、見た目は途切れない
 * @param {number} value いまの位置（translate）
 * @param {number} right 範囲の右端。実体の組の先頭
 * @param {number} width 1組ぶんの幅
 * @returns {number} 範囲に収めた位置
 */
const foldCrawl = (value: number, right: number, width: number): number => {
    if (width <= 0) return value;

    let next = value;

    while (next <= right - width) next += width;
    while (next > right) next -= width;

    return next;
};

export { CRAWL_PER_SEC, MAX_DELTA, foldCrawl };
